jQuery(document).ready(function($) {

  $('.product-registration-helper-popup-trigger').on('click', function(e){

    if ($(this).hasClass('product-number-trigger')) {
      $('.helper-popup-content').html('<img src="'+ window.helperPopupData.productNumberImage +'" alt="Product Number Guide" />');
    } else if ($(this).hasClass('serial-number-trigger')) {
      $('.helper-popup-content').html('<img src="'+ window.helperPopupData.serialNumberImage +'" alt="Serial Number Guide" />');
    }

    $('.helper-popup').removeClass('d-none');
  });

  $('.helper-popup-close').on('click', function(e){
    $('.helper-popup').addClass('d-none');
  })

  $(document).on('click', '.helper-popup-container', function(e) {
    if ($(e.target).is('.helper-popup-container')) {
      $(this).parent().addClass('d-none');
    }
  });

  $('#section-footer a, .header a').each(function() {
    if (this.hostname && this.hostname !== window.location.hostname) {
      $(this).attr('target', '_blank').attr('rel', 'noopener');
    }
  });

  function qiki_prf_submit_redirect() {
    const target = document.querySelector('.product-registration-form-wrapper');
    if (!target) {
      console.log('Element .product-registration-form-wrapper not found.');
      return;
    }

    let capturedProductNumber = '';

    function syncProductNumberToDataAttribute() {
      try {
        const input = target.querySelector('input[name="contact[product-number]"]') ||
                      document.querySelector('input[name="contact[product-number]"]');
        if (input && input.value.trim() !== '') {
          target.setAttribute('data-product-number', input.value.trim());
        }
      } catch (e) {
        console.warn('Could not update data attribute:', e);
      }
    }

    target.addEventListener('input', syncProductNumberToDataAttribute, true);
    target.addEventListener('change', syncProductNumberToDataAttribute, true);
    target.addEventListener('submit', syncProductNumberToDataAttribute, true);

    function handleRedirect() {

      syncProductNumberToDataAttribute();

      let redirectUrl = 'https://staminaproducts.com/pages/product-registration-thank-you';

      const productNumber = target.getAttribute('data-product-number') || target.dataset.productNumber;

      if (productNumber) {
        redirectUrl += `?product_number=${encodeURIComponent(productNumber)}`;
      }

      window.location.href = redirectUrl;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const isSuccessNode = 
              (node.classList && node.classList.contains('bcontact-success-notification')) ||
              (node.querySelector && node.querySelector('.bcontact-success-notification'));

            if (isSuccessNode) {
              observer.disconnect();
              handleRedirect();
            }
          }
        });
      });
    });

    observer.observe(target, {
      childList: true,
      subtree: true,  
      characterData: true
    });
  }

  const product_registration_target = document.querySelector('.product-registration-form-wrapper');
  if (product_registration_target) {
    qiki_prf_submit_redirect();
  }

  const container = document.getElementById('product-image-scrollable');
  const upBtn = document.querySelector('.product-scroll-up');
  const downBtn = document.querySelector('.product-scroll-down');

  if (upBtn) {
    upBtn.addEventListener('click', () => {
      container.scrollBy({ top: -50, behavior: 'smooth' });
    });
  }

  if (downBtn) {
    downBtn.addEventListener('click', () => {
      container.scrollBy({ top: 50, behavior: 'smooth' });
    });
  }

  if (!container || !upBtn || !downBtn) return; 

  function updateButtons() {
    if (container.scrollTop === 0) {
      upBtn.classList.add('product-scroll-hidden');
    } else {
      upBtn.classList.remove('product-scroll-hidden');
    }

    if (container.scrollHeight <= container.clientHeight || container.scrollTop + container.clientHeight >= container.scrollHeight) {
      downBtn.classList.add('product-scroll-hidden');
    } else {
      downBtn.classList.remove('product-scroll-hidden');
    }
  }

  updateButtons();

  container.addEventListener('scroll', updateButtons);

});